module.exports = "/_next/static/images/apple-line-276a8a76c81ceb2e9184475ff6d7093b.svg";